
export enum StopWindowNoteTypeCd {
	FBDS = 'FBDS',
	INTERNAL = 'Internal',
	TIME_DATE_CRITICAL = 'TimeDateCritical'}

